

















import { Component, Vue } from 'vue-property-decorator';
import {default as GameLogic, Hotspot, HotspotOption, MenuType} from '@/services/GameLogic.ts';
import Repeater from '@/components/Repeater.vue';
import Klokjes from "@/components/Klokjes.vue";
import LocaleText from "@/components/LocaleText.vue";
import LocaleService from "../services/LocaleService";
import {TutorialTipPosition} from "../store/store";

interface IPos { x: number; y: number; }

@Component({
    components: {Klokjes, Repeater, LocaleText},
    computed: {
        getComputerRoute():string { return '/day/' + this.$route.params.day + '/computer'; },
    },
    methods: {
        handleExitConfirm(exit:boolean):void {
            this.$store.state.showExitConfirm = false;
            if( exit ) {
                this.$router.push('feedback');
            }
        },
    },
    created() {
        this.$store.commit('hideTip', 'algemeen.tutorial.tip3.text');
        if( this.$store.getters.hasSeenTip('algemeen.tutorial.tip2.text') ) {
            this.$store.commit('showTip', { key: 'algemeen.tutorial.tip4.text', position: TutorialTipPosition.bottom});
        }
        else {
            this.$store.commit('showTip', { key: 'algemeen.tutorial.tip2.text', position: TutorialTipPosition.center});
        }
    }
})
export default class NurseMenu extends Vue {
}
